<nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)" [nzSize]="'small'"
  nzType="card" class="m-[-10px] p-0">
  <nz-tab *ngFor="let tab of availableSubTabs; let i = index" [nzTitle]="tab">
    <ng-template nz-tab>
      <ng-container *ngIf="selectedTabIndex === i">
        <ng-container *ngIf="getSubTabComponentIndex(i) === 0">
          <app-roles></app-roles>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 1">
          <app-environment></app-environment>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 2">
          <app-excursion></app-excursion>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 3">
          <app-sensor-type></app-sensor-type>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 4">
          <app-customer-capability></app-customer-capability>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 5">
          <app-checklist-master></app-checklist-master>
        </ng-container>
      </ng-container>
    </ng-template>
  </nz-tab>
</nz-tabset>